export var query = "query getPayments($paymentMethod: String!) {\n  payments {\n    offlineInstruction(paymentMethod: $paymentMethod) {\n      offlineInstruction\n    }\n  }\n}";
//# sourceMappingURL=getPayments.graphql.js.map